import React from 'react';
import { BrowserRouter, Link, Route, Switch, withRouter, Redirect } from 'react-router-dom';

import './Page.css';

import PageRavens from './PageRavens';
import PageTest from './PageTest';


class PageRouter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

  }


  

  render() {
    const url = this.props.match.url

    return (
          

            <Switch>

              <Route path={`${url}/ravens`}>
                <PageRavens
                />
              </Route>

              <Route path={`${url}/test`}>
                <PageTest/>
              </Route>

            </Switch>
    )
  }
}

export default withRouter(PageRouter);
